import React, { FC, PropsWithChildren } from 'react';

import Background from './Background';
import Footer from './Footer';
import Header from './Header';
import useStyles from './styles.module';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.layout}>
      <Background />
      <Header />
      <div className={classes.container}>{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
